function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsettledbills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10570",
    transform: "translate(-564 -274)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5853",
    width: 48,
    height: 48,
    rx: 8,
    transform: "translate(564 274)",
    style: {
      fill: "#f8e6b6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10572"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "file (6)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41434",
    d: "M11.2 2H5.6A1.6 1.6 0 0 0 4 3.6v12.8A1.6 1.6 0 0 0 5.6 18h9.6a1.6 1.6 0 0 0 1.6-1.6V7.6z",
    style: {
      fill: "none",
      stroke: "#d84c29",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(577 288)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41435",
    d: "M13 2v5.6h5.6",
    transform: "translate(575.2 288)",
    style: {
      fill: "none",
      stroke: "#d84c29",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsettledbills);
export default __webpack_public_path__ + "static/media/unsettledbills.c4cf9cce5378657bf2b3076a48eec13a.svg";
export { ForwardRef as ReactComponent };